import { render, staticRenderFns } from "./FormUnit.vue?vue&type=template&id=6f3ef4ca&"
import script from "./FormUnit.vue?vue&type=script&lang=ts&"
export * from "./FormUnit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f3ef4ca')) {
      api.createRecord('6f3ef4ca', component.options)
    } else {
      api.reload('6f3ef4ca', component.options)
    }
    module.hot.accept("./FormUnit.vue?vue&type=template&id=6f3ef4ca&", function () {
      api.rerender('6f3ef4ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WorkOrder/FormUnit.vue"
export default component.exports